import { render } from "./AnalyticsDashboard.vue?vue&type=template&id=38018ebf"
import script from "./AnalyticsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AnalyticsDash/AnalyticsDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38018ebf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38018ebf', __exports__)) {
    api.reload('38018ebf', __exports__)
  }
  
  module.hot.accept("./AnalyticsDashboard.vue?vue&type=template&id=38018ebf", () => {
    api.rerender('38018ebf', render)
  })

}


export default __exports__